import React from 'react';
import InstructionsDialog from '../../../InstructionsDialog';
import { isMobile, isTablet } from 'react-device-detect';
import Cookies from 'js-cookie';
import { PuzzleNames } from '../../../../utils/types';
import { DOMAIN } from '../../shared/utils';
import { MegarubigramStore } from '../MegarubigramStore';

const closeInstructions = () => {
  MegarubigramStore.update(s => {
    s.instructionsAreOpen = false;
    s.isSoftPaused = false;
  });

  Cookies.set(`${PuzzleNames.Megarubigram}InstructionsDismissed`, 'true', {
    domain: DOMAIN,
    expires: 365,
  });
};

const Instructions = () => {
  const isOpen = MegarubigramStore.useState(s => s.instructionsAreOpen);
  const isTouch = isMobile || isTablet;

  return (
    <InstructionsDialog isOpen={isOpen} onClose={closeInstructions}>
      <h1 className="instructionsTitle">How to Play the Megarubigram</h1>
      <div className="instructionsBody">
        <ul>
          <li>Rotate and flip until every row and column <span className="italicText">longer than two letters</span> spells a word from left-to-right and top-to-bottom.</li>
          <li>Flip the 3x3 subgrids by {isTouch ? 'tapping' : 'clicking'} their non-corner cells.</li>
          {!isTouch && <li>Right-click the rotate buttons to rotate counterclockwise.</li>}
          <li>No obscure words and mostly no proper names.</li>
          {isMobile && <li>
            This puzzle is harder to solve on mobile due to the density of the UI, but you can try if you wish.
          </li>}
        </ul>
      </div>
    </InstructionsDialog>
  );
};

export default Instructions;